<template>
  <div class="contractList">
    <div class="intro-y flex items-center mt-8">
      <h2 class="text-lg font-medium mr-auto" style='font-size: 20px;font-weight: 700;'>合同管理</h2>
    </div>
    <div class="intro-y box overflow-hidden mt-5">
      <expire/>
    </div>
    <div class="search-form intro-y box p-5 mt-5" style='padding-bottom: 0;'>
      <el-form :form="form" inline>
        <el-form-item label="资产出租地址明细：">
          <el-input v-model='form.assetAddressDetail' placeholder="请输入地址进行查询" style="width:240px;"/>
        </el-form-item>
        <el-form-item label="管理单位名称：">
          <el-select style="width: 200px" v-model='form.companyId' placeholder="请选择">
            <el-option
              v-for="item in unitOptions"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="合同日期：">
          <el-date-picker
              v-model='time'
              value-format="yyyy-MM-dd"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              type="daterange"/>
        </el-form-item>
        <el-form-item label="合同编号：">
          <el-input v-model='form.contractNo' placeholder="请输入合同编号" style="width:240px;"/>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="searchHandle" :loading='loading'>
            搜索
          </el-button>
        </el-form-item>
        <br/>
        <el-form-item label="合同预警筛选：" style="margin-top:16px;margin-bottom:20px;">
          <checkBox @changeData="changeData"></checkBox>
        </el-form-item>
      </el-form>
    </div>
    <div class="intro-y overflow-auto mt-5">
      <table class="table table-report -mt-2">
        <thead>
        <tr>
          <th class="whitespace-no-wrap">欠租预警</th>
          <th class="whitespace-no-wrap">管理单位名称</th>
          <th class="text-center whitespace-no-wrap">合同编号</th>
          <th class="text-center whitespace-no-wrap">资产出租地址明细</th>
          <th class="text-center whitespace-no-wrap">合同开始时间</th>
          <th class="text-center whitespace-no-wrap">合同结束时间</th>
          <th class="text-center whitespace-no-wrap">当期欠收租金</th>
          <th class="text-center whitespace-no-wrap">租金收取日期</th>
          <th class="text-center whitespace-no-wrap">操作</th>
        </tr>
        </thead>
        <tbody>
        <tr
            v-for="(item, index) in dataList"
            :key="index"
            class="intro-x"
        >
          <td>
            <div class="font-medium whitespace-no-wrap">
              <div style="width: 15px;height: 15px;border-radius: 50%;background:#FF3843;" v-if="item.earlyWarning == 2"></div>
              <div style="width: 15px;height: 15px;border-radius: 50%;background:#CFBE00;" v-if="item.earlyWarning == 1"></div>
              <div style="width: 15px;height: 15px;border-radius: 50%;background:#20A47C;" v-if="item.earlyWarning == 0"></div>
            </div>
          </td>
          <td>
            <div class="font-medium whitespace-no-wrap">{{
                item.managementEnterprise
              }}</div>
          </td>
          <td>
            <div class="font-medium whitespace-no-wrap">{{
                item.contractNo
              }}</div>
          </td>
          <td>
            <div class="font-medium whitespace-no-wrap">{{
                item.assetAddressDetail
              }}</div>
          </td>
          <td>
            <div class="font-medium whitespace-no-wrap">{{
                item.contractStartDate
              }}</div>
          </td>
          <td>
            <div class="font-medium whitespace-no-wrap">{{
                item.contractEndDate
              }}</div>
          </td>
          <td>
            <div class="font-medium whitespace-no-wrap">{{
                item.currentRentArrears
              }}</div>
          </td>
          <td>
            <div class="font-medium whitespace-no-wrap">{{
                item.rentCollectionDate
              }}</div>
          </td>
          <td class="table-report__action w-40 border-b dark:border-dark-5">
            <div class="flex justify-center items-center">
              <a class="mr-3 text-theme-1" href="javascript:;" @click="checkHandle(item)" style="white-space:nowrap;">
                查看
              </a>
            </div>
          </td>
        </tr>
        </tbody>
      </table>
    </div>

    <div
        class="intro-y col-span-12 flex flex-wrap sm:flex-row sm:flex-no-wrap items-center justify-space-between mt-5"
    >
      <el-pagination
          layout="prev, pager, next"
          :background='false'
          :page-size="form.perPage"
          :current-page="form.page"
          @current-change="handleTableChange"
          :total="total">
      </el-pagination>
      <select class="w-20 input box mt-3 sm:mt-0" @change='onShowSizeChange' v-model='form.perPage'>
        <option :value='10'>10</option>
        <option :value='25'>25</option>
        <option :value='35'>35</option>
        <option :value='50'>50</option>
      </select>
    </div>
  </div>

</template>

<script>
import {contractMonitor, contractContractList, getCompanyList} from '../../api/contract.js'
import expire from './components/expire'
import checkBox from '../../components/checkBox'

export default {
  name: "contractList",
  components: {
    expire,
    checkBox
  },
  data() {
    return {
      total: 0,
      unitOptions: [],
      form: {
        assetAddressDetail: '',
        companyId: -1,
        contractStartDate: '',
        contractEndDate: '',
        contractNo:'',
        earlyWarnings: [],
        perPage: 10,
        page: 1
      },
      loading: false,
      columns: [
        {
          title: '欠租预警',
          dataIndex: 'earlyWarning',
          scopedSlots: {customRender: 'earlyWarning'},
        },
        {
          title: '管理单位名称',
          dataIndex: 'managementEnterprise',
        },
        {
          title: '合同编号',
          dataIndex: 'contractNo',
        },
        {
          title: '资产出租地址明细',
          dataIndex: 'assetAddressDetail',
        },
        {
          title: '合同开始时间',
          dataIndex: 'contractStartDate',
        },
        {
          title: '合同结束时间',
          dataIndex: 'contractEndDate',
        },
        {
          title: '当期欠收租金',
          dataIndex: 'currentRentArrears',
        },
        {
          title: '租金收取日期',
          dataIndex: 'rentCollectionDate',
        },
        {
          title: '操作',
          dataIndex: "action",
          scopedSlots: {
            customRender: "action",
          }
        },
      ],
      dataList: [],
      time: [],
    }
  },
  methods: {
    changeData(params) {
      this.form.earlyWarnings = params
    },
    onShowSizeChange(e) {
      this.form.page = 1;
      this.getList();
    },
    handleTableChange(page) {
      this.form.page = page;
      this.getList();
    },
    searchHandle() {
      this.form.page = 1
      this.getList();
    },
    checkHandle(params) {
      let url=this.$router.resolve({path: '/assetManagement/assetDetail', query: {assetId: params.assetId, activeKey: 'contract'}}).href
      window.open(url)
    },
    getList() {
      let para = Object.assign({}, this.form)
      para.earlyWarnings = para.earlyWarnings.join(',');
      this.loading = true;
      contractContractList(para).then(res => {
        this.loading = false
        let data = res.data
        if (data.code === '000') {
          this.dataList = data.content.list
          this.total = data.content.total
        } else {
          this.dataList = []
          this.total = 0
        }
      }).catch(err => {
        this.loading = false
        console.log(err);
      }).finally(() => {
        this.loading = false
      })
    },
    getCompanyList() {
      getCompanyList().then(res => {
        let data = res.data
        if (data.code === '000') {
          this.unitOptions = data.content.list
        } else {
          this.unitOptions = []
        }
      }).catch(err => {
        console.log(err);
      })
    }
  },
  created() {
    this.getCompanyList()
    this.getList()
  },
  watch: {
    time: function () {
      this.form.contractStartDate = this.time[0] || ''
      this.form.contractEndDate = this.time[1] || ''
    }
  },
}
</script>


<style scoped lang="scss">
.contractList {
  min-height: calc(100vh - 84px);

  .list {
    background: #fff;
    padding: 30px 20px;

  }

  .page {
    margin-top: 15px;
    text-align: right;
  }
}
</style>
